export enum DocumentsTypeEnum {
  FEDERALID_FRONT = "FEDERALID_FRONT",
  FEDERALID_BACK = "FEDERALID_BACK",
  PROOF_OF_RESIDENCE = "PROOF_OF_RESIDENCE",
}
